import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { Col, Row, Button, FormGroup, Label, Input, ButtonGroup } from "reactstrap";
import axios from "axios";
import Rating from "react-rating";
import Moment from "moment";
import { extendMoment } from "moment-range";
import _ from "lodash";
import ImageUploading from "react-images-uploading";
import { saveAs } from "file-saver";
import { trackPromise } from "react-promise-tracker";

import Switch from "react-switch";
import classes from "./VendorForm.module.scss";
import StarEmpty from "./../../../../assets/icons/star_empty.png";
import StarFull from "./../../../../assets/icons/star_full.png";
import Table from "./../../../general/Table/Table";
import Form from "./../../../general/Form/Form";
import TruckForm from "./../TruckForm/TruckForm";
import PaymentScheduleModal from "./../PaymentScheduleModal/PaymentScheduleModal";
import EditProblemModal from "./../../fixlist/EditProblemModal/EditProblemModal"
import profileIcon from "./../../../../assets/icons/profilePictureBase64";
import FileUpload from "./../../../general/FileListUpload/FileListUpload";
import Loading from "../../../wrapper/Loading/Loading";
import { boxiPrimary } from "../../../../assets/style/colors";
import CommunicationWidgetBox from "../../../general/CommunicationWidget/CommunicationWidgetBox.js"

const moment = extendMoment(Moment);
const config = {
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true
};

class VendorForm extends Component {
  state = {
    vendorId: null,
    vendorPicture: "",
    vendorCode: "",
    vendorRating: 0,
    vendorEligible: false,
    vendorPictureReporting: true,
    vendorName: "",
    vendorNickname: "",
    vendorPhoneNumber: "",
    vendorEmail: "",
    vendorSSN: "",
    vendorReferredBy: "",
    vendorNotes: "",
    vendorAddress: "",
    vendorEIN: "",
    vendorMovesFreightFor: "",
    vendorCity: "",
    vendorAreaCovered: "",
    vendorPipelineSelected: "",
    vendorDateAdded: "",
    vendorCity: "",
    vendorAreaCovered: "",
    vendorFiles: [],
    vendorAgreements: [],
    vendorAgreementsArr: [],
    vendorFilesToAdd: [],
    vendorFilesToUpdate: [],
    vendorFilesToDelete: [],
    vendorTrucks: [],
    vendorTrucksToAdd: [],
    vendorTrucksToUpdate: [],
    paymentScheduleToAdd: [],
    paymentScheduleToUpdate: [],
    paymentScheduleModalData: {},
    fullVendorTruckData: [],
    paymentScheduleModalShow: false,
    paymentScheduleModalEdit: false,
    selectedTruckId: null,
    vendorFixList: [],
    problemModalShow: false,
    problemModalEdit: false,
    isLoading: false
  };

  onFormSubmitHandler = async (e) => {
    e.preventDefault();
    let vendorData = {
      referred_by: this.state.vendorReferredBy,
      notes: this.state.vendorNotes,
      profile_picture: this.state.vendorPicture,
      name: this.state.vendorName,
      phone_num: this.state.vendorPhoneNumber,
      email: this.state.vendorEmail,
      ssn: this.state.vendorSSN,
      address: this.state.vendorAddress,
      ein: this.state.vendorEIN,
      moves_for: this.state.vendorMovesFreightFor,
      city: this.state.vendorCity,
      area_covered: this.state.vendorAreaCovered,
      pipeline: this.state.vendorPipelineSelected,
      date_added: this.props.edit ? this.state.vendorDateAdded : moment().format("YYYY-MM-DD"),
      code: this.state.vendorCode,
      rating: this.state.vendorRating,
      eligible: this.state.vendorEligible,
      nickname: this.state.vendorNickname,
      picture_reporting: this.state.vendorPictureReporting,
    };
    if (this.props.edit) {
      try {
        let res = await axios.put(`${process.env.REACT_APP_API_HOST}/vendor/${this.state.vendorId}`, vendorData, config);
        if (res.status === 200 && res.data.updated_vendor && res.data.updated_vendor[0].vendor_id) {
          let vendorTruckUpdateSuccess = await this.saveVendorTrucks();
          let paymentScheduleUpdateSuccess = await this.savePaymentSchedules();
          let vendorFilesUpdateSuccess = await this.saveVendorFiles();
          if (vendorTruckUpdateSuccess && paymentScheduleUpdateSuccess && vendorFilesUpdateSuccess) {
            alert("Vendor Was Updated");
            this.props.history.push(`/dashboard/admin/drive`);
            window.location.reload();
          }
        }
      } catch (err) {
        console.log(err);
      }
    } else {
      try {
        let res = await axios.post(`${process.env.REACT_APP_API_HOST}/vendor`, vendorData, config);
        if (res.status === 200 && res.data.new_vendor && res.data.new_vendor[0].vendor_id) {
          let vendorTruckAddSuccess = await this.saveVendorTrucks(res.data.new_vendor[0].vendor_id);
          let vendorFilesAddSuccess = await this.saveVendorFiles(res.data.new_vendor[0].vendor_id);
          if (vendorTruckAddSuccess && vendorFilesAddSuccess) {
            alert("Vendor Was Created");
            this.props.history.push(`/dashboard/admin/drive`);
            window.location.reload();
          }
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  deleteVendor = async (e) => {
    e.preventDefault();
    if (window.confirm(`Are you sure you want to delete this vendor?\nThis action is irreversible.`)) {
      let success = true;
      // delete trucks
      for (let truck of this.state.vendorTrucks) {
        try {
          let res = await axios.delete(`${process.env.REACT_APP_API_HOST}/truck/${truck[0]}`, {
            withCredentials: true
          });
          if (!(res.status === 200 && res.data.deleted_truck && res.data.deleted_truck[0].truck_id)) {
            success = false;
            break;
          }
        } catch (err) {
          console.log(err);
          success = false;
          break;
        }
      }

      // delete files
      for (let file of this.state.vendorFiles) {
        try {
          let res = await axios.delete(`${process.env.REACT_APP_API_HOST}/vendor/file/${file[0]}`, { withCredentials: true });
          if (!(res.status === 200 && res.data.deleted_file && res.data.deleted_file[0].file_id)) {
            success = false;
            break;
          }
        } catch (err) {
          console.log(err);
          success = false;
          break;
        }
      }

      // Clear queue of files to delete
      this.state.vendorFiles = [];

      //delete vendor
      try {
        let res = await axios.delete(`${process.env.REACT_APP_API_HOST}/vendor/${this.state.vendorId}`, {
          withCredentials: true
        });
        if (!(res.status === 200 && res.data.deleted_vendor && res.data.deleted_vendor[0].vendor_id)) {
          success = false;
        }
      } catch (err) {
        console.log(err);
      }
      // redirect based off of results
      if (success) {
        alert("Vendor was deleted");
        this.props.history.push(`/dashboard/admin/drive`);
        window.location.reload();
      } else {
        alert("There was a problem deleting the vendor");
        window.location.reload();
      }
    }
  };

  componentDidMount = () => {
    if (this.props.edit) {
      this.setState({
        isLoading: true
      })
      this.loadVendor(this.props.match.params.id);
      window.setTimeout(this.loadCampaigns, 500);
    }
  };

  saveVendorTrucks = async (vendorId) => {
    let success = true;
    for (let truck of this.state.vendorTrucksToAdd) {
      // if id is provided, use it. otherwise use state vendor id
      truck.vendor_id = vendorId ? vendorId : this.state.vendorId;
      let res = await axios.post(`${process.env.REACT_APP_API_HOST}/truck`, truck, config);
      // check if request was successful
      if (!(res.status === 200 && res.data.new_truck && res.data.new_truck[0].truck_id)) success = false;
    }
    return success;
  };

  savePaymentSchedules = async () => {
    let success = true;
    // add new payment schedules
    for (let paymentSchedule of this.state.paymentScheduleToAdd) {
      let res = await axios.put(
        `${process.env.REACT_APP_API_HOST}/truck/${paymentSchedule.truckId}/payment_schedule`,
        paymentSchedule.data,
        config
      );
      // check if request was successful
      if (!(res.status === 200 && res.data.new_ps && res.data.new_ps[0].payment_schedule_id)) success = false;
    }
    // update any existing payment schedules
    for (let paymentSchedule of this.state.paymentScheduleToUpdate) {
      let res = await axios.put(
        `${process.env.REACT_APP_API_HOST}/truck/${paymentSchedule.truckId}/payment_schedule/${paymentSchedule.paymentScheduleId}`,
        paymentSchedule.data,
        config
      );
      // check if request was successful
      if (!(res.status === 200 && res.data.updated_ps && res.data.updated_ps[0].payment_schedule_id)) success = false;
    }

    return success;
  };

  saveVendorFiles = async (vendorId) => {
    let id = vendorId ? vendorId : this.state.vendorId;
    let success = true;
    // add new vendor files
    for (let file of this.state.vendorFilesToAdd) {
      let data = {
        name: file.file_name,
        vendor_id: parseInt(id),
        file_data: file.data_url
      };
      let res = await axios.post(`${process.env.REACT_APP_API_HOST}/vendor/file`, data, config);
      // check if request was successful
      if (!(res.status === 200 && res.data.new_file && res.data.new_file[0].vendor_id)) success = false;
    }

    // Clear queue of files to add
    this.state.vendorFilesToAdd = [];

    // delete vendor files
    for (let id of this.state.vendorFilesToDelete) {
      let res = await axios.delete(`${process.env.REACT_APP_API_HOST}/vendor/file/${id}`, { withCredentials: true });
      if (!(res.status === 200 && res.data.deleted_file && res.data.deleted_file[0].file_id)) success = false;
    }

    // Clear queue of files to delete
    this.state.vendorFilesToDelete = [];

    return success;
  };

  addTruckHandler = (truck) => {
    // show new truck in UI
    let vendorTruck = ["", truck.size_ref, truck.make, "", truck.name, truck.license_plate, "", ""];
    // update state
    this.setState({
      vendorTrucks: this.state.vendorTrucks.concat([vendorTruck]),
      vendorTrucksToAdd: this.state.vendorTrucksToAdd.concat(truck)
    });
  };

  loadVendor = async (id) => {
    try {
      // get vendor information
      let res = await trackPromise(axios.get(`${process.env.REACT_APP_API_HOST}/vendor/${id}`, { withCredentials: true }));
      if (res.status === 200 && res.data.vendor && res.data.vendor.length > 0) {
        let vendor = res.data.vendor[0];
        let vendorTrucks = [];
        let vendorFiles = [];
        let vendorAgreements = [];
        // get vendor truck information
        res = await trackPromise( axios.get(`${process.env.REACT_APP_API_HOST}/vendor/${id}/truck`, { withCredentials: true }));
        if (res.status === 200 && res.data.trucks) {
          vendorTrucks = res.data.trucks.map((truck) => [
            truck.truck_id,
            truck.size_ref,
            truck.make,
            truck.active_campaign ? truck.active_campaign.join(" || ") : "",
            truck.name,
            truck.license_plate,
            truck.active_tracking,
            truck.gps_provider ? truck.gps_provider : "N/A",
            truck.ps_id ? true : false
          ]);
          vendorFiles = vendor.files.map((file) => [file.file_id, file.name]);
          vendorAgreements = vendor.agreements.map((agreement) => [agreement.id, agreement.agreement_name]);
        }
          this.setState({
            vendorId: id,
            vendorPicture: vendor.profile_pic,
            vendorCode: vendor.code,
            vendorRating: vendor.rating,
            vendorEligible: vendor.eligible,
            vendorPictureReporting: vendor.picture_reporting,
            vendorName: vendor.name,
            vendorNickname: vendor.nickname,
            vendorPhoneNumber: vendor.phone_num,
            vendorEmail: vendor.email,
            vendorSSN: vendor.ssn,
            vendorReferredBy: vendor.referred_by,
            vendorNotes: vendor.notes,
            vendorAddress: vendor.address,
            vendorEIN: vendor.ein,
            vendorMovesFreightFor: vendor.moves_for,
            vendorCity: vendor.city,
            vendorAreaCovered: vendor.area_covered,
            vendorPipelineSelected: vendor.pipeline,
            vendorDateAdded: vendor.date_added ? moment(vendor.date_added).format("MM/DD/YYYY") : null,
            vendorFiles: vendorFiles,
            vendorAgreements: vendorAgreements,
            vendorAgreementsArr: vendor.agreements,
            vendorTrucks: vendorTrucks ? vendorTrucks : null,
            isLoading: false
            //vendorFixList: fixListData,
          });
      }
    } catch (err) {
      console.log(err);
    }
    this.getVendorFixListData();
};
  getVendorFixListData = async () =>{
    let fixListData = [];
    try{
      let fixListRes = await trackPromise( axios.get(`${process.env.REACT_APP_API_HOST}/vendor/${this.state.vendorId}/fixlist`, {withCredentials: true}));
    if (fixListRes.status === 200 && fixListRes.data){
      fixListData = fixListRes.data.problem.map((problem) => [
        problem.truck_problem_id,
        problem.truck_name,
        problem.description,
        moment(problem.date_identified).format("YYYY-MM-DD"),
        problem.bleeding_stopped,
        problem.reprint_ordered,
        problem.solution,
        moment(problem.target_close_date).format("YYYY-MM-DD"),

      ]);
      this.setState({
        vendorFixList: fixListData,
      });
    }
  } catch (err) {
    console.log(err);
  }
};
  vendorPictureChangeHandler = (imageList) => {
    this.setState({
      vendorPicture: imageList[0].dataURL
    });
  };

  vendorCodeChangeHandler = (e) => {
    this.setState({
      vendorCode: e.target.value
    });
  };

  vendorRatingChangeHandler = (value) => {
    this.setState({
      vendorRating: value
    });
  };
  vendorEligibleChangeHandler = (checked) =>{
    this.setState({
      vendorEligible: checked
    });
  };
  vendorPictureReportingChangeHandler = (checked) => {
    this.setState({
      vendorPictureReporting: checked
    });
  };

  vendorNameChangeHandler = (e) => {
    this.setState({
      vendorName: e.target.value
    });
  };

  vendorNicknameChangeHandler = (e) => {
    this.setState({
      vendorNickname: e.target.value
    });
  };

  vendorPhoneNumberChangeHandler = (e) => {
    this.setState({
      vendorPhoneNumber: e.target.value
    });
  };

  vendorEmailChangeHandler = (e) => {
    this.setState({
      vendorEmail: e.target.value
    });
  };

  vendorSSNChangeHandler = (e) => {
    this.setState({
      vendorSSN: e.target.value
    });
  };

  vendorReferredByChangeHandler = (e) => {
    this.setState({
      vendorReferredBy: e.target.value
    });
  };
  vendorNotesChangeHandler = (e) => {
    this.setState({
      vendorNotes: e.target.value
    });
  };
  vendorAddressChangeHandler = (e) => {
    this.setState({
      vendorAddress: e.target.value
    });
  };

  vendorEINChangeHandler = (e) => {
    this.setState({
      vendorEIN: e.target.value
    });
  };

  vendorMovesFreightForChangeHandler = (e) => {
    this.setState({
      vendorMovesFreightFor: e.target.value
    });
  };

  vendorCityChangeHandler = (e) => {
    this.setState({
      vendorCity: e.target.value
    })
  }

  vendorAreaCoveredChangeHandler = (e) => {
    this.setState({
      vendorAreaCovered: e.target.value
    })
  }

  vendorPipelineChangeHandler = (selected) => {
    this.setState({
      vendorPipelineSelected: selected
    })
  }

  vendorFileChangeHandler = (files) => {
    this.setState({
      vendorFilesToAdd: files
    });
  };

  vendorFilesHeaders = ["id", "Name"];
  vendorFilesButtons = [
    {
      display: "Download",
      onClickHandler: async (index, id) => {
        try {
          let res = await axios.get(`${process.env.REACT_APP_API_HOST}/vendor/file/${id}`, { withCredentials: true });
          if (res.status === 200 && res.data.file && res.data.file[0].file_id) {
            let file = res.data.file[0];
            // start file download
            saveAs(file.data, file.name);
          }
        } catch (err) {
          console.log(err);
          alert("Problem downloading file");
        }
      }
    },
    {
      display: "Delete",
      onClickHandler: async (index, id) => {
        // make ui changes for delete
        let files = _.cloneDeep(this.state.vendorFiles);
        let indexToRemove = files.findIndex((file) => file[0] === id);
        files.splice(indexToRemove, 1);
        this.setState({
          vendorFiles: files,
          vendorFilesToDelete: this.state.vendorFilesToDelete.concat(id)
        });
      }
    }
  ];

  vendorAgreementsHeaders = ["id", "Name"];
  vendorAgreementsButtons = [
    {
      display: "Download",
      onClickHandler: async (index, id) => {
        try {
          const link = document.createElement('a');
          link.href = this.state.vendorAgreementsArr.filter(agreement => agreement.id === id)[0].file_url;
          link.download = 'template.pdf'; // Set desired filename
          link.click();
    
          link.remove();
        } catch (err) {
          console.log(err);
          alert("Problem downloading file");
        }
      }
    }
  ];

  vendorFixListHeaders = ["id", "Truck Name", "Description", "Date Identified", "Bleeding Stopped", "Reprint Ordered", "Solution", "Target Close Date"];
  vendorFixListButtons = [
    {
      display: "View",
      onClickHandler: async (index, id) => {
        if (id){
          this.setState({
            problemModalEdit: true,
            problemModalShow: true,
            problemModalData:{
              id: id,
            },
          });
        }
      }
    }
  ];
  toggleProblemModal = (refreshTable) => {
    this.setState({
      problemModalShow: false,
    });
    if (refreshTable){
      this.getVendorFixListData();
    }
  };
  newProblemModal = () =>{
    this.setState({
      problemModalEdit: false,
      problemModalShow: true,
      vendorPageId: this.state.vendorId,
    });
  }
  vendorTrucksHeaders = [
    "id",
    "Size Ref",
    "Make",
    "Active Campaign",
    "Truck Name",
    "License Plate",
    "Active Tracking",
    "GPS Provider",
    "On Payment Schedule"
  ];
  vendorTrucksButtons = [
    {
      display: "View",
      onClickHandler: (index, id) => {
        this.props.history.push(`/dashboard/admin/drive/vendor/truck/edit/${id}`);
      }
    },
    {
      display: "Edit Payment Schedule",
      onClickHandler: async (index, id) => {
        let paymentSchedule = await this.checkPaymentSchedule(id);
        console.log('---paymentSchedule---', id, paymentSchedule);
        // if payment schedule exists, load the information in edit
        if (paymentSchedule) {
          this.setState({
            paymentScheduleModalShow: true,
            paymentScheduleModalEdit: true,
            paymentScheduleModalData: paymentSchedule,
            selectedTruckId: id,
            selectedPaymentScheduleId: paymentSchedule.payment_schedule_id
          });
        } else {
          // otherwise, open modal to add payment schedule
          this.setState({
            paymentScheduleModalShow: true,
            paymentScheduleModalEdit: false,
            selectedTruckId: id
          });
        }
      }
    }
  ];
  checkPaymentSchedule = async (id) => {
    try {
      let res = await axios.get(`${process.env.REACT_APP_API_HOST}/truck/${id}/payment_schedule`, { withCredentials: true });
      if (res.status === 200 && res.data.payment_schedule && res.data.payment_schedule.length > 0) {
        console.log(res.data.payment_schedule);
        let current = res.data.payment_schedule.find((schedule) => {
          let startDate = moment(schedule.start_date);
          let endDate = moment(schedule.end_date);
          let currentDate = moment();
          return moment().range(startDate, endDate).contains(currentDate);
        });
        return current;
      }
      return false;
    } catch (err) {
      console.log(err);
    }
  };

  togglePaymentScheduleModal = () => {
    this.setState({
      paymentScheduleModalShow: false,
      selectedTruckId: null,
      paymentScheduleModalData: {}
    });
  };

  addPaymentSchedule = (startDate, endDate, campaignId, paymentAmount) => {
    // disable list item for editing until it's saved
    this.disableTruckEdit(this.state.selectedTruckId);
    // format data for request
    let paymentSchedule = {
      truckId: this.state.selectedTruckId,
      data: { campaign_id: campaignId, start_date: startDate, end_date: endDate, monthly_rate: paymentAmount }
    };
    // add payment schedule to be added on save and reset modal state
    this.setState({
      paymentScheduleToAdd: this.state.paymentScheduleToAdd.concat(paymentSchedule),
      paymentScheduleModalShow: false,
      paymentScheduleModalEdit: false,
      selectedTruckId: null
    });
  };

  updatePaymentSchedule = (startDate, endDate, campaignId, paymentAmount) => {
    // disable list item for editing until it's saved
    this.disableTruckEdit(this.state.selectedTruckId);
    // format data for request
    let paymentSchedule = {
      truckId: this.state.selectedTruckId,
      paymentScheduleId: this.state.selectedPaymentScheduleId,
      data: { campaign_id: campaignId, start_date: startDate, end_date: endDate, monthly_rate: paymentAmount }
    };
    // add payment schedule to be updated on save and reset modal state
    this.setState({
      paymentScheduleToUpdate: this.state.paymentScheduleToUpdate.concat(paymentSchedule),
      paymentScheduleModalShow: false,
      paymentScheduleModalEdit: false,
      selectedTruckId: null,
      selectedPaymentScheduleId: null
    });
  };

  deletePaymentSchedule = async () => {

    // disable list item for editing until it's saved
    this.disableTruckEdit(this.state.selectedTruckId);

    if (window.confirm(`Are you sure you want to delete this payment schedule?\nThis action is irreversible.`)) {
      let res = await axios.delete(
        `${process.env.REACT_APP_API_HOST}/payment_schedule/${this.state.selectedPaymentScheduleId}`,
        config
      );
      if (res.status === 200 && res.data.deleted_ps && res.data.deleted_ps[0].payment_schedule_id) {
        alert("Payment schedule was deleted");

        // reset modal state
        this.setState({
          paymentScheduleModalShow: false,
          paymentScheduleModalEdit: false,
          selectedTruckId: null,
          selectedPaymentScheduleId: null
        });

        window.location.reload();
      }
    }

    // reset modal state
    this.setState({
      paymentScheduleModalShow: false,
      paymentScheduleModalEdit: false,
      selectedTruckId: null,
      selectedPaymentScheduleId: null
    });
  };

  disableTruckEdit = (id) => {
    let vendorTrucks = _.cloneDeep(this.state.vendorTrucks);
    let index = this.state.vendorTrucks.findIndex((obj) => obj[0] === id);
    vendorTrucks[index][0] = null;
    this.setState({
      vendorTrucks: vendorTrucks
    });
  };

  render() {
    const style = {
      padding: "15px 20px",
      marginBottom: "25px"
    };
    const sectionStyle = {
      boxShadow: "none",
      border: "1px solid rgba(0, 0, 0, 0.1)"
    };
    const buttonStyle = {
      float: "right",
      fontSize: "26px",
      marginLeft: "20px"
    };
    return (
      <Fragment>
        <Loading loading={this.state.isLoading} label="Loading Vendor..."></Loading>
        <Form title={this.props.edit ? "Edit Vendor" : "Create New Vendor"} formStyle={style}>
          <Row form className="mb-4">
            <Col md={7}>
              <Row form>
                <Col md={5} className="pl-2 pr-2">
                  <FormGroup>
                    <ImageUploading defaultValue={[{ dataURL: profileIcon }]} onChange={this.vendorPictureChangeHandler}>
                      {({ imageList, onImageUpload }) => {
                        if (this.state.vendorPicture) {
                          imageList[0].dataURL = this.state.vendorPicture;
                          imageList[0].key = this.state.vendorPicture;
                        }
                        return (
                          <div className={classes.vendorPictureWrapper}>
                            {imageList.length === 0 ? (
                              <button
                                className={classes.pictureUploadButton}
                                onClick={(e) => {
                                  e.preventDefault();
                                  onImageUpload();
                                }}
                              >
                                Upload Vendor Picture
                              </button>
                            ) : null}
                            {imageList.map((image) => (
                              <div key={image.key}>
                                <img className={classes.vendorPicture} src={image.dataURL} />
                                <div>
                                  <button
                                    className={classes.pictureButton}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      image.onUpdate();
                                    }}
                                  >
                                    Upload
                                  </button>
                                  <button
                                    className={classes.pictureButton}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      image.onRemove();
                                    }}
                                  >
                                    Remove
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                        );
                      }}
                    </ImageUploading>
                  </FormGroup>
                </Col>
                <Col md={7} className="pr-4">
                  <FormGroup>
                    <Label for="vendorCode">Vendor Code</Label>
                    <Input
                      type="text"
                      value={this.state.vendorCode ? this.state.vendorCode : ""}
                      onChange={this.vendorCodeChangeHandler}
                      placeholder="Enter vendor code"
                    />
                  </FormGroup>
                  <FormGroup>
                    <div className="mb-2">Vendor Rating</div>
                    <Rating
                      initialRating={this.state.vendorRating ? this.state.vendorRating : 0}
                      onChange={this.vendorRatingChangeHandler}
                      emptySymbol={<img src={StarEmpty} className={classes.icon} />}
                      fullSymbol={<img src={StarFull} className={classes.icon} />}
                    />
                  </FormGroup>
                  <Row className="pl-3">
                    <FormGroup>
                    <Label for="eligibleToggle">Qualified Vendor</Label>
                    <Row style = {{marginLeft: '10px'}}>
                      <Switch
                      onColor={boxiPrimary}
                      id="eligibleToggle"
                      checked={this.state.vendorEligible}
                      onChange={this.vendorEligibleChangeHandler} />
                    </Row>
                    </FormGroup>
                    <FormGroup style={{marginLeft: '20px'}}>
                    <Label for="eligibleToggle">Picture Reporting</Label>
                    <Row style = {{marginLeft: '10px'}}>
                      <Switch
                      onColor={boxiPrimary}
                      id="eligibleToggle"
                      checked={this.state.vendorPictureReporting}
                      onChange={this.vendorPictureReportingChangeHandler} />
                    </Row>
                    </FormGroup>
                  </Row>
                </Col>
              </Row>
              <Row form>
                <Col md={6} className="pl-2 pr-2">
                  <FormGroup>
                    <Label for="vendorName">Vendor Name</Label>
                    <Input
                      type="text"
                      value={this.state.vendorName ? this.state.vendorName : ""}
                      onChange={this.vendorNameChangeHandler}
                      placeholder="Enter vendor name"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="vendorNickname">Vendor Nickname</Label>
                    <Input
                      type="text"
                      value={this.state.vendorNickname ? this.state.vendorNickname : ""}
                      onChange={this.vendorNicknameChangeHandler}
                      placeholder="Enter vendor nickname"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="vendorPhoneNumber">Vendor Phone Number</Label>
                    <Input
                      type="text"
                      value={this.state.vendorPhoneNumber ? this.state.vendorPhoneNumber : ""}
                      onChange={this.vendorPhoneNumberChangeHandler}
                      placeholder="Enter vendor phone number"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="vendorEmail">Vendor Email</Label>
                    <Input
                      type="email"
                      value={this.state.vendorEmail ? this.state.vendorEmail : ""}
                      onChange={this.vendorEmailChangeHandler}
                      placeholder="Enter vendor email"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="vendorSSN">Vendor SSN</Label>
                    <Input
                      type="text"
                      value={this.state.vendorSSN ? this.state.vendorSSN : ""}
                      onChange={this.vendorSSNChangeHandler}
                      placeholder="Enter vendor SSN"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="vendorReferredBy">Referred By</Label>
                    <Input
                      type="text"
                      value={this.state.vendorReferredBy ? this.state.vendorReferredBy : ""}
                      onChange={this.vendorReferredByChangeHandler}
                      placeholder="Enter vendor referral"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="vendorNotes">Notes</Label>
                    <Input
                      type="textarea"
                      style={{ height: 120 }}
                      value={this.state.vendorNotes ? this.state.vendorNotes : ""}
                      onChange={this.vendorNotesChangeHandler}
                      placeholder="Enter vendor notes"
                    />
                  </FormGroup>
                </Col>
                <Col md={6} className="pl-2 pr-2">
                  <FormGroup>
                    <Label for="vendorAddress">Vendor Address</Label>
                    <Input
                      type="text"
                      value={this.state.vendorAddress ? this.state.vendorAddress : ""}
                      onChange={this.vendorAddressChangeHandler}
                      placeholder="Enter vendor address"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="vendorEIN">Vendor EIN</Label>
                    <Input
                      type="text"
                      value={this.state.vendorEIN ? this.state.vendorEIN : ""}
                      onChange={this.vendorEINChangeHandler}
                      placeholder="Enter vendor EIN"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="vendorMovesFreightFor">Moves Freight For</Label>
                    <Input
                      type="text"
                      value={this.state.vendorMovesFreightFor ? this.state.vendorMovesFreightFor : ""}
                      onChange={this.vendorMovesFreightForChangeHandler}
                      placeholder="Enter who vendor moves freight for"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label>Vendor City</Label>
                    <Input
                      type="text"
                      value={this.state.vendorCity ? this.state.vendorCity : ""}
                      onChange={this.vendorCityChangeHandler}
                      placeholder="Enter which city vendor is in"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label>Area Covered</Label>
                    <Input
                      type="text"
                      value={this.state.vendorAreaCovered ? this.state.vendorAreaCovered : ""}
                      onChange={this.vendorAreaCoveredChangeHandler}
                      placeholder="Enter area covered by vendor"
                    />
                  </FormGroup>
                  <FormGroup>
                      <Label>Pipeline</Label>
                      <ButtonGroup>
                        <Button color="info" onClick={() => this.vendorPipelineChangeHandler("Cold")} active={this.state.vendorPipelineSelected === "Cold"}>Cold</Button>
                        <Button color="info" onClick={() => this.vendorPipelineChangeHandler("Warm")} active={this.state.vendorPipelineSelected === "Warm"}>Warm</Button>
                        <Button color="info" onClick={() => this.vendorPipelineChangeHandler("Approved")} active={this.state.vendorPipelineSelected === "Approved"}>Approved</Button>
                        <Button color="info" onClick={() => this.vendorPipelineChangeHandler("Worked With")} active={this.state.vendorPipelineSelected === "Worked With"}>Worked With</Button>
                        <Button color="info" onClick={() => this.vendorPipelineChangeHandler("End Of Life")} active={this.state.vendorPipelineSelected === "End Of Life"}>End Of Life</Button>
                      </ButtonGroup>
                  </FormGroup>
                  <Row>
                    <Col xs={6}>
                      <FormGroup>
                        <Label>Date Added</Label>
                        <div>{this.state.vendorDateAdded}</div>
                      </FormGroup>
                    </Col>
                    <Col xs={6}>
                      <FormGroup>
                        <Label>Number of Trucks</Label>
                        <div>{this.state.vendorTrucks ? this.state.vendorTrucks.length : ""}</div>
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col md={5}>
              <Row form>
                <Col xs={12} className="pl-4 pr-4">
                  {this.props.edit ? (
                    <Button color="danger" style={buttonStyle} onClick={this.deleteVendor}>
                      Delete
                    </Button>
                  ) : null}
                  <Button color="primary" style={buttonStyle} onClick={this.onFormSubmitHandler}>
                    {this.props.edit ? "Save" : "Create"}
                  </Button>
                </Col>
              </Row>
              <Row form>
                <Col xs={12} className="pl-4 pr-4">
                  <FormGroup className="files">
                    <div className={classes.communicationWidgetBox}>
                      {this.state.vendorPhoneNumber  && < CommunicationWidgetBox nameOfVendor = {this.state.vendorName} phoneNumber = {this.state.vendorPhoneNumber} vendorID={this.state.vendorId}></CommunicationWidgetBox>}
                    </div>
                    <FileUpload fileChangeHandler={this.vendorFileChangeHandler} />
                    {this.state.vendorFilesToDelete.length > 0 ? (
                      <Label className="pl-4 pr-4">Click "Save" to save file changes</Label>
                    ) : null}
                    <Table
                      title="Files"
                      id="vendor-files-table"
                      headers={this.vendorFilesHeaders}
                      data={this.state.vendorFiles}
                      buttons={this.vendorFilesButtons}
                      sectionStyle={sectionStyle}
                      noSearch
                    />

                    {/* <div style={{ marginTop: 10 }}>
                      <Table
                        title="Agreements"
                        id="vendor-agreements-table"
                        headers={this.vendorAgreementsHeaders}
                        data={this.state.vendorAgreements}
                        buttons={this.vendorAgreementsButtons}
                        sectionStyle={sectionStyle}
                        noSearch
                      />
                    </div> */}

                  </FormGroup>
                </Col>
              </Row>
              {/* This Communication widget is used to explicitly use communication Tab features */}
            </Col>
          </Row>
          <Row form className="mb-4">
            <Col xs={12}>
              <Table
                title="All Vendor Trucks"
                id="vendor-trucks-table"
                headers={this.vendorTrucksHeaders}
                data={this.state.vendorTrucks}
                buttons={this.vendorTrucksButtons}
                sectionStyle={sectionStyle}
              />
            </Col>
          </Row>
          <Row form>
            <Col xs={12}>
            <Table
            title="Vendor Fix List"
            id="vendor-fix-list-table"
            headers={this.vendorFixListHeaders}
            data={this.state.vendorFixList}
            buttons={this.vendorFixListButtons}
            sectionStyle={sectionStyle} />
            </Col>
            <Button style={{marginLeft: 25 + 'px'}} onClick={this.newProblemModal}>  New Fix List Item </Button>
          </Row>
        </Form>
        <TruckForm add={this.addTruckHandler} />
        <PaymentScheduleModal
          show={this.state.paymentScheduleModalShow}
          toggleModal={this.togglePaymentScheduleModal}
          edit={this.state.paymentScheduleModalEdit}
          data={this.state.paymentScheduleModalData}
          add={this.addPaymentSchedule}
          update={this.updatePaymentSchedule}
          delete={this.deletePaymentSchedule}
        />
        <EditProblemModal
          show={this.state.problemModalShow}
          toggleModal={this.toggleProblemModal}
          edit={this.state.problemModalEdit}
          data={this.state.problemModalData}
          vendorPageId={this.state.vendorId}
          //add={this.addPaymentSchedule}
          //update={this.updatePaymentSchedule}
          //delete={this.deletePaymentSchedule}
        />
      </Fragment>
    );
  }
}

export default withRouter(VendorForm);
